import { type FC } from 'react';

import { type TPictureTemplateParams } from 'shared/types/bannerContext';

import styles from './Picture.css';

type TPictureProps = {
  context: TPictureTemplateParams;
};

export const Picture: FC<TPictureProps> = ({ context }) => {
  const { imageURL, alt, width, reference } = context;

  return (
    <a
      data-testid="picture"
      className={styles['container']}
      href={reference}
      rel="noreferrer noopener nofollow"
      style={{ width }}
      target="_blank"
    >
      <img alt={alt} className={styles['image']} src={imageURL} />
    </a>
  );
};
